import { User } from "../../models/user/user.model";

export class Base {
  public industryKey: string = "CURRENT_INDUSTRY";
  public eErgoTrainingCompleteKeyPrefix = "EERGO_TRAINING_COMPLETE";

  public userDetailsKey = "MEMIC_USER_DETAIL";

  public basePageTitle: string = "Safety Director | ";
  public user: User;

  //get industry from local storage
  getIndustry(): string {
    return localStorage.getItem(this.industryKey) ?? "All";
  }

  setIndustry(industry: string): void {
    // for some reason this.industryKey wasn't working so I used the actual string "CURRENT_INDUSTRY" and it worked :(
    localStorage.setItem(this.industryKey, industry);
  }

  setUserDetailsToLocalStorage(user: User) {
    this.user = user;
    localStorage.setItem(this.userDetailsKey, JSON.stringify(this.user));
  }

  getUserDetailsFromLocalStorage(): User {
    let userDetailObj = localStorage.getItem(this.userDetailsKey) as string;
    return JSON.parse(userDetailObj);
  }

  deleteUserDetailFromLocalStorage(): void {
    localStorage.removeItem(this.userDetailsKey);
  }

  getEErgoTrainingStatus(emailAddress: string): boolean {
    let eErgoTrainingStatus = localStorage.getItem(`${this.eErgoTrainingCompleteKeyPrefix}_${emailAddress}`);

    return ((eErgoTrainingStatus && eErgoTrainingStatus == 'true')) ? true : false;
  }

  setEErgoTrainingStatus(emailAddress: string, traningStatus: boolean): void {
    localStorage.setItem(`${this.eErgoTrainingCompleteKeyPrefix}_${emailAddress}`, traningStatus.toString());
  }
}
